import { connect } from 'react-redux';
import Subcontracts from '../components/subcontracts';

const mapStateToProps = state => ({
  vendors: state.order.subcontracts.vendors,
  isVendorsLoading: state.order.subcontracts.isVendorsLoading,
});

export default connect(
  mapStateToProps,
)(Subcontracts);
